<div class="bg-custom">
<div class="dialog-content py-0 m-4">
    <div>
        <div class="row d-flex justify-content-end">
            <button class="btn btn_sm btn_danger text_white" >
                Exception Counter : {{data.bypassCount ?? 0}}
            </button>
        </div>
        <div class="row d-flex justify-content-around">
            <div class="col-6" *ngFor="let button of data.summary">
              <!-- <button class="btn btn_sm btn_white text_dark_blue mt-3" (click)="onClickButton(button)">
                {{ button.name }}
              </button>
              <h2 class="sub_title_1 text_dark_blue mb-0">{{ button.count }}</h2> -->
              <mat-card class="col-12 btn_white text_dark_blue mt-3 cursor-pointer" (click)="onClickButton(button)">
                <mat-card-content>
                    <p class="paragraph mb-1">{{ button.name }}</p>
                    <h2 class="sub_title_1 text_dark_blue mb-0">{{ button.count }}</h2>
                    </mat-card-content>
                    </mat-card>
            </div>
          </div>
          
        <div class="col-12 text_end mt-4 align_btn">
            <button class="btn btn_sm btn_primary text_white mt-2" *ngIf="!loadingOnSave; else buttonLoader" (click)="onClickBypass()">
               Quick Pass
            </button>
        </div>
        
    </div>
</div>
</div>
<ng-template #buttonLoader>
    <button-loader></button-loader>
  </ng-template>
<!-- Actions -->
<!-- <div mat-dialog-actions class="dialog-actions mb-2 p-4">
    <button class="btn btn_sm btn_white text_dark_blue" (click)="onClickClose()">
        No, Cancel
    </button>
    <button class="btn btn_sm btn_danger" [disabled]="reason === ''" (click)="onSubmit()" cdkFocusInitial>
        Yes, Proceed
    </button>
</div> -->